export function buildThreadFocusPath({ hubSlug, threadId, replyId = null, entry = null }) {
  const safeHub = encodeURIComponent(String(hubSlug || ""));
  const safeThread = encodeURIComponent(String(threadId || ""));
  const base = `/h/${safeHub}?focus=thread:${safeThread}`;
  const reply = replyId ? `&replyId=${encodeURIComponent(String(replyId))}` : "";
  const source = entry ? `&entry=${encodeURIComponent(String(entry))}` : "";
  return `${base}${reply}${source}`;
}

export function dispatchOpenThreadPanel({ hubSlug, threadId, replyId = null }) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent("open-thread-panel", {
      detail: {
        hubSlug: String(hubSlug || ""),
        threadId: String(threadId || ""),
        replyId: replyId || null,
      },
    })
  );
}

